var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.484866 8.21461L3.75849 1.66339C4.26988 0.639977 5.72946 0.639979 6.24086 1.6634L9.51448 8.21461C10.0967 9.37979 8.89941 10.6335 7.7097 10.1044L5.56327 9.14989C5.52186 9.13148 5.47978 9.11519 5.43717 9.10103L5.43717 6.72917C5.43717 6.48754 5.2413 6.29167 4.99967 6.29167C4.75805 6.29167 4.56217 6.48754 4.56217 6.72917L4.56217 9.10102C4.51957 9.11519 4.47749 9.13148 4.43608 9.14989L2.28965 10.1044C1.09994 10.6335 -0.0973705 9.37979 0.484866 8.21461ZM3.83301 13C3.59138 13 3.39551 12.8041 3.39551 12.5625L3.39551 11.3958C3.39551 11.1542 3.59138 10.9583 3.83301 10.9583C4.07463 10.9583 4.27051 11.1542 4.27051 11.3958L4.27051 12.5625C4.27051 12.8041 4.07463 13 3.83301 13ZM5.72884 12.5625C5.72884 12.8041 5.92472 13 6.16634 13C6.40797 13 6.60384 12.8041 6.60384 12.5625L6.60384 11.3958C6.60384 11.1542 6.40797 10.9583 6.16634 10.9583C5.92472 10.9583 5.72884 11.1542 5.72884 11.3958L5.72884 12.5625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterBtn);
export default __webpack_public_path__ + "static/media/enterBtn.5e9d4e08457a984e6fe5bcd09ca5a79d.svg";
export { ForwardRef as ReactComponent };